import React, { useState, useEffect } from "react";
import Footer from "../components/Footer";
import Hero from "../components/Hero";
import faqbg from '../assets/images/faq.jpg';

const faqs = [
  {
    id: "q1",
    question: "What is DCode?",
    answer:
      "DCode is a developer analytics platform that transforms your team's productivity data and code quality metrics into actionable visual insights. Track code health, monitor project progress, and make data-driven engineering decisions—all from a single, unified dashboard.",
  },
  {
    id: "q2",
    question: "What programming languages does DCode support?",
    answer:
      "The productivity and analytics features of DCode are language-independent. Code quality analysis, including code fitness, is currently supported for Java, Python, and C# using DesigniteJava, DPy, and Designite.",
  },
  {
    id: "q3",
    question: "Is DCode free?",
    answer:
      "The DCode platform, hosted on dcodehub.com, is available free of charge to its users. To enable code quality analysis and code fitness trend features, the platform relies on Designite’s code analysis tools, which require a valid license to generate quality reports. Details about Designite’s professional licenses can be found <a href='https://www.designite-tools.com/buy' target='_blank' rel='noopener noreferrer'>here</a>.",
  },
  {
    id: "q4",
    question: "Does DCode keep my source code on its servers?",
    answer:
      "The DCode platform does not receive or store your source code on its servers. Instead, it receives and stores code quality reports generated by Designite tools. Designite Actions that are the primary source of your project's code quality information, analyze your codebase locally or in your CI environment using Designite tools. The code quality reports contain metrics and detected smells but do not include the actual source code. Subsequently, the actions upload these reports to the DCode servers. Even when you connect DCode with your GitHub repository, DCode only accesses the repository metadata and does not retrieve or store the source code.",
  },
  {
    id: "q5",
    question: "How can I request a new feature or report a bug?",
    answer:
      "You may log your feature request or bug report on <a href='https://github.com/DesigniteTools/issues' target='_blank'>our public issue tracking board.</a>"
  }
];

function FAQ() {
  const [openId, setOpenId] = useState(faqs[0].id);

  useEffect(() => {
    document.title = "DCode | FAQ";
  }, []);

  const toggleFeature = (id) => {
    setOpenId((prevId) => (prevId === id ? null : id));
  };
  return (
    <div>
      <Hero bgimg={faqbg} content="Everything you need to know about the DCode" title="FAQs" />
      <section id="faq">
        <div className="container">
          <h1 className="faq-h1" data-aos="fade-right">
            Frequently Asked Questions
          </h1>
          <div className="row">

            <div className="col-lg-2 col-md-2 col-12 col-sm-12"></div>
            <div className="col-lg-8 col-md-8 col-12 col-sm-12 faq-section" data-aos="fade-right">
              {faqs.map((faq) => (
                <div key={faq.id} className="feature-item" >
                  <h3
                    className="question d-flex justify-content-between align-items-center"
                    onClick={() => toggleFeature(faq.id)}
                    style={{ cursor: "pointer" }}
                  >
                    {faq.question}
                    <i
                      className={`fa ${openId === faq.id ? "fa-angle-up" : "fa-angle-down"
                        }`}
                      aria-hidden="true"
                    />
                  </h3>
                  <div
                    className={`answer-wrapper ${openId === faq.id ? "open" : ""
                      }`}
                  >
                    <p dangerouslySetInnerHTML={{ __html: faq.answer }} className="answer" />
                  </div>
                </div>

              ))}
            </div>

            <div className="col-lg-2 col-md-2 col-12 col-sm-12"></div>

          </div>
        </div>

      </section>
      <Footer />
    </div>
  )
}

export default FAQ;